import * as React from 'react';

import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import { Props as TextProps } from 'components/Text';
import getField, { Field } from '../ComposableTableField';

type Props = {
  number: number;
  isPercentage?: boolean;
  label?: string;
  labelProps: Partial<TextProps>;
};

function ErrorCell({ number, isPercentage, label, labelProps }: Props) {
  if (isNaN(number)) {
    return <span />;
  }
  const hasErrors = number > 0;

  if (label && hasErrors) {
    return (
      <TextWithIcon
        weight="semibold"
        color="lava"
        icon="explanation-circle"
        iconColor="lava"
        {...labelProps}>
        {label}
      </TextWithIcon>
    );
  }

  const percentage = number * 100;
  const content = isPercentage ? `${percentage.toFixed()}%` : number;
  return (
    <Text
      weight={hasErrors ? 'semibold' : 'normal'}
      color={hasErrors ? 'lava' : 'inherit'}
      {...labelProps}>
      {label || content}
    </Text>
  );
}

export function getErrorCellGenerator<T>(fieldName: Field<T>, labelProps?: Partial<TextProps>) {
  return (data: T) => {
    return <ErrorCell number={getField(data, fieldName)} labelProps={labelProps || {}} />;
  };
}

export function getErrorPercentageCellGenerator<T>(
  fieldName: Field<T>,
  labelProps?: Partial<TextProps>
) {
  return (data: T) => {
    return (
      <ErrorCell number={getField(data, fieldName)} isPercentage labelProps={labelProps || {}} />
    );
  };
}

export function getErrorTextCellGenerator<T>(
  fieldName: Field<T>,
  numberOfErrorsField: Field<T>,
  labelProps?: Partial<TextProps>
) {
  return (data: T) => {
    return (
      <ErrorCell
        label={getField(data, fieldName)}
        number={getField(data, numberOfErrorsField)}
        labelProps={labelProps || {}}
      />
    );
  };
}
